import axios from "axios";
import { store } from "../app/store";
import { beginGlobalLoading, endGlobalLoading } from "../features/ui/uiSlice";

const LOADING_EXCLUDE: Array<(url?: string, method?: string) => boolean> = [
  (url, method) => !!url?.includes("s3.amazonaws.com") && method?.toUpperCase() === "PUT",
];

export const http = axios.create({
  withCredentials: false,
});

let inflight = 0;

http.interceptors.request.use(
  (config) => {
    const excluded = LOADING_EXCLUDE.some((fn) => fn(config.url, config.method));
    if (!excluded) {
      inflight += 1;
      store.dispatch(beginGlobalLoading());
    }

    if (config.url?.includes("s3.amazonaws.com")) {
      if (config.headers) {
        delete (config.headers as any).Authorization;
        delete config.headers.common?.Authorization;
      }
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

http.interceptors.response.use(
  (response) => {
    inflight = Math.max(0, inflight - 1);
    if (inflight === 0) store.dispatch(endGlobalLoading());
    return response;
  },
  (error) => {
    inflight = Math.max(0, inflight - 1);
    if (inflight === 0) store.dispatch(endGlobalLoading());
    return Promise.reject(error);
  }
);
